// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

//Dirigo Custom Functions
import {getToken, handleResponseError} from '@src/utility/Utils'
const token = getToken()

// ** Axios Imports
import axios from 'axios'
import { BackendUrl } from '@src/BackendUrl'


export const fetchEvents = createAsyncThunk('orgUnitCalendar/fetchEvents', async settings => {
  const selectedHotel = JSON.parse(localStorage.getItem('selectedHotel'))

    console.log('New org calendar store', settings)

    if (settings.filters.length !== 0) {
      console.log('With filter render')

      const filters = settings.filters
      const calendarView = settings.calendarView
      const dates = settings.dates
      
      //NEW TEST ENDPOINT
      try {

        const selectedApp = {
          ApplicationId: "3000",
          ApplicationName: "HRManagement",
          EntityId: "3006",
          EntityName: "Time&Attendance",
          ErpCompanyId: selectedHotel.ErpCompanyId
        }
        const dirigoData = await axios.post(`${BackendUrl()}/stafftimer/calendarEventsFilteredAUTHTEST/`, {selectedHotel, filters, calendarView, dates, selectedApp, token})
      
        console.log('Filtered Calendar Events Data:', dirigoData.data)

        return dirigoData.data  // OTI GYRNAEI APO EDW TO STELNEI STO ARXEIO /store/index.js sti grammi 68!!!!!!!!!!!!
      
      } catch (error) {  //Error handling
        const errMessage = handleResponseError(error)
        console.log(errMessage)
      }

    } else { //Bring all data from backend
      console.log('No filter render')

      //NEW TEST ENDPOINT
      try {
        //const selectedApp = JSON.parse(localStorage.getItem('selectedApp'))
        const organizationUnit = settings.organizationUnit?.value
        const organizationUnitName = settings.organizationUnit?.label

        const selectedApp = {
          ApplicationId: "3000",
          ApplicationName: "HRManagement",
          EntityId: "3006",
          EntityName: "Time&Attendance",
          ErpCompanyId: selectedHotel.ErpCompanyId
        }
        const dirigoData = await axios.post(`${BackendUrl()}/stafftimer/calendarEventsFromOrgUnit/`, {selectedHotel, token, selectedApp, organizationUnit, organizationUnitName})
        console.log('Calendar Events Data {endpoint: calendarEventsFromOrgUnit}:', dirigoData.data)

        return dirigoData.data  // OTI GYRNAEI APO EDW TO STELNEI STO ARXEIO /store/index.js sti grammi 68!!!!!!!!!!!!

      } catch (error) {  //Error handling
        const errMessage = handleResponseError(error)
        console.log(errMessage)
      }
    }
})


export const orgUnitCalendarSlice = createSlice({
  name: 'orgUnitCalendar',
  initialState: {
    events: [],
    resources: [],    //**-* DIRIGO CUSTOM DATA ADDED!!!
    employeeList: [], //**-* DIRIGO CUSTOM DATA ADDED!!!
    branchList: [],    //**-* DIRIGO CUSTOM DATA ADDED!!!
    departmentList: [], //**-* DIRIGO CUSTOM DATA ADDED!!!
    businessUnitList: [], //**-* DIRIGO CUSTOM DATA ADDED!!!
    selectedBusinessUnit: {}, //**-* DIRIGO CUSTOM DATA ADDED!!!
    selectedEvent: {}
  },
  reducers: {
    selectEvent: (state, action) => {
      state.selectedEvent = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchEvents.fulfilled, (state, action) => {

        //console.log('BUILDER CASE (events,resources) at store/index.js:', action.payload.events)
        if (action.payload) {
          state.events = action.payload.events
          state.resources = action.payload.resources
          state.employeeList = action.payload.employeeList
          state.branchList = action.payload.branchList
          state.departmentList = action.payload.departmentList
          state.businessUnitList = action.payload.businessUnitList
          state.selectedBusinessUnit = action.payload.selectedBusinessUnit
        } else {
          state.resources = [{error : 'No user access to calendar, please try login again.'}]
        }
      })
      // .addCase(updateFilter.fulfilled, (state, action) => {
      //   if (state.selectedCalendars.includes(action.payload)) {
      //     state.selectedCalendars.splice(state.selectedCalendars.indexOf(action.payload), 1)
      //   } else {
      //     state.selectedCalendars.push(action.payload)
      //   }
      // })
      // .addCase(updateAllFilters.fulfilled, (state, action) => {
      //   const value = action.payload
      //   let selected = []
      //   if (value === true) {
      //     selected = ['Personal', 'Business', 'Family', 'Holiday', 'ETC']
      //   } else {
      //     selected = []
      //   }
      //   state.selectedCalendars = selected
      // })
  }
})

export const { selectEvent } = orgUnitCalendarSlice.actions

export default orgUnitCalendarSlice.reducer
